import { render, staticRenderFns } from "./promotionSettings.vue?vue&type=template&id=65896d04&scoped=true&"
import script from "./promotionSettings.vue?vue&type=script&lang=js&"
export * from "./promotionSettings.vue?vue&type=script&lang=js&"
import style0 from "./promotionSettings.vue?vue&type=style&index=0&id=65896d04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65896d04",
  null
  
)

export default component.exports